import { jsx as _jsx } from "react/jsx-runtime";
import { Users } from 'lucide-react';
import { createModulePerms } from '@wit-support/ui-domain';
import { AdminsListPage } from './routes/list-page.js';
const { Provider: AdminsModulePermsProvider, usePerms: useAdminsPerms } = createModulePerms({
    canCreate: false,
    canUpdate: false,
    canDisable: false,
});
export { AdminsModulePermsProvider };
function AdminsPageRoute() {
    const { canCreate, canUpdate, canDisable } = useAdminsPerms();
    return _jsx(AdminsListPage, { canCreate: canCreate, canUpdate: canUpdate, canDisable: canDisable });
}
export const adminsModule = {
    id: 'admins',
    label: 'Admins',
    icon: Users,
    permission: 'admins.list',
    workspace: 'system',
    order: 20,
    description: 'Who can sign into this panel and what they can do.',
    routes: [{ path: '/', component: AdminsPageRoute }],
};
export { AdminsListPage } from './routes/list-page.js';
export { ChangePasswordDialog } from './forms/change-password-dialog.js';
export { setAdminApiBaseUrl } from './api.js';
//# sourceMappingURL=index.js.map